module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SearchView.js"));
	}, "OrderSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderSearchView!./src/pages/Shop/Member/TradeManage/OrderList/Search/SearchView.js
// module id = 1011
// module chunks = 438